import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'biel-sources',
  styleUrl: 'biel-sources.css',
  shadow: true,
})
export class BielSources {
  @Prop() sources: { title: string; url: string }[];
  @Prop() sourcesText: string = 'Sources';
  @State() showSources: boolean = false;

  toggleSources() {
    this.showSources = !this.showSources;
  }

  render() {
    return (
      <div class="biel-message__sources">
        <button class="biel-message__sources-toggle" onClick={() => this.toggleSources()}>
          <span>{this.sourcesText}</span>
          {this.showSources ?
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-up"><path d="m18 15-6-6-6 6"/></svg> :
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>
          }
        </button>
        {this.showSources && (
          <ul class="biel-message__sources-list">
            {this.sources.map(source => (
              <li class="biel-message__source-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5f6368" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link-2"><path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/></svg> <a href={source.url} target="_blank">{source.title}</a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
